import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-base text-white">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
        <XCircle className="w-16 h-16 text-white/40 mx-auto mb-6" />
        <h1 className="font-heading font-black text-3xl mb-2">{t("payment_cancelled_title")}</h1>
        <p className="font-mono text-sm text-white/50 mb-8">{t("payment_cancelled_desc")}</p>
        <Link to="/profile">
          <Button data-testid="back-to-profile-btn" className="bg-signal text-black hover:bg-signal/90 rounded-sm font-semibold">
            {t("back_profile")}
          </Button>
        </Link>
      </div>
    </div>
  );
}
